import React from 'react'
import { Layout } from './Layout'
import { ShippingRatePanelProvider } from './Context'

export const ShippingRatePanel = () => {
  return (
    <ShippingRatePanelProvider>
      <Layout />
    </ShippingRatePanelProvider>
  )
}
